// extracted by mini-css-extract-plugin
export var checkbox = "_8a-0";
export var circle = "_8a-3";
export var horizontalContainer = "_8a-7";
export var sm = "_8a-5";
export var switch0 = "_8a-2";
export var switchDisabled = "_8a-8";
export var switchEnabled = "_8a-1";
export var textSwitchContainer = "_8a-9";
export var textSwitchOption = "_8a-a";
export var textSwitchOptionSelected = "_8a-b";
export var verticalContainer = "_8a-6";
export var xs = "_8a-4";